class CollectionDescription extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('.collection-description__content');
    if (!content) return;

    // Find the text node containing '...' or '…'
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, null, false);
    let node;
    let found = false;
    let targetNode = null;
    let targetIndex = -1;

    while ((node = walker.nextNode())) {
      const idx = node.nodeValue.indexOf('...');
      const idxUnicode = node.nodeValue.indexOf('…');
      const finalIdx = idx !== -1 ? idx : idxUnicode;

      if (finalIdx !== -1) {
        targetNode = node;
        targetIndex = finalIdx;
        found = true;
        break;
      }
    }

    if (!found) return;

    // Execute the DOM split
    const { button, hiddenContainer } = this.splitDOM(targetNode, targetIndex, content);

    // Create the "Read Less" button to be placed at the end of the revealed text
    const readLess = document.createElement('button');
    readLess.type = 'button';
    readLess.className = 'collection-description__toggle-less';
    readLess.textContent = 'Read Less';
    readLess.style.display = 'none';

    // Find the last element inside hiddenContainer to append readLess inline
    let lastElement = hiddenContainer;
    while (lastElement.lastElementChild) {
      lastElement = lastElement.lastElementChild;
    }
    lastElement.appendChild(readLess);

    // Toggle logic
    button.addEventListener('click', () => {
      button.style.display = 'none';
      hiddenContainer.style.display = 'inline';
      readLess.style.display = 'block';
    });

    readLess.addEventListener('click', () => {
      button.style.display = 'block';
      hiddenContainer.style.display = 'none';
      readLess.style.display = 'none';
    });
  }

  splitDOM(node, index, root) {
    const parent = node.parentNode;
    const textBefore = node.nodeValue.substring(0, index);
    const textAfter = node.nodeValue.substring(index + (node.nodeValue.includes('...') ? 3 : 1));
    
    node.nodeValue = textBefore;

    // Set original parent to display: inline so it flows with the hidden remainder when shown
    parent.style.setProperty('display', 'inline', 'important');
    parent.style.setProperty('margin', '0', 'important');

    // Create the "Read More" button
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'collection-description__toggle';
    button.textContent = 'Read More';

    // Create the hidden container (span)
    const hiddenContainer = document.createElement('span');
    hiddenContainer.className = 'collection-description__hidden';
    hiddenContainer.style.display = 'none';
    
    // Create the right parent (cloned original parent, display inline)
    const rightParent = parent.cloneNode(false);
    rightParent.style.setProperty('display', 'inline', 'important');
    rightParent.style.setProperty('margin', '0', 'important');
    
    // Add split text to the right parent
    rightParent.appendChild(document.createTextNode(textAfter));
    
    // Move all siblings after node in original parent to rightParent
    let next = node.nextSibling;
    while (next) {
      const temp = next.nextSibling;
      rightParent.appendChild(next);
      next = temp;
    }
    
    hiddenContainer.appendChild(rightParent);

    // Bubble up and split ancestors up to root
    let currentLeft = parent;
    let currentRight = rightParent;
    let ancestor = parent.parentNode;
    
    while (ancestor && ancestor !== root) {
      const newRight = ancestor.cloneNode(false);
      // Make block ancestors inline so they flow continuously when expanded
      newRight.style.setProperty('display', 'inline', 'important');
      newRight.style.setProperty('margin', '0', 'important');
      
      newRight.appendChild(currentRight);
      
      let sibling = currentLeft.nextSibling;
      while (sibling) {
        const temp = sibling.nextSibling;
        newRight.appendChild(sibling);
        sibling = temp;
      }
      
      hiddenContainer.appendChild(newRight);
      
      currentLeft = ancestor;
      currentRight = newRight;
      ancestor = ancestor.parentNode;
    }

    // Move any remaining siblings of currentLeft (direct children of root) to hiddenContainer
    let sibling = currentLeft.nextSibling;
    while (sibling) {
      const temp = sibling.nextSibling;
      hiddenContainer.appendChild(sibling);
      sibling = temp;
    }

    // Insert button and hiddenContainer after currentLeft in root
    root.insertBefore(button, currentLeft.nextSibling);
    root.insertBefore(hiddenContainer, button.nextSibling);

    return { button, hiddenContainer };
  }
}

if (!customElements.get('collection-description')) {
  customElements.define('collection-description', CollectionDescription);
}
